module.exports = __webpack_public_path__ + "img/Small-Semi-Elliptical-Attachment-L-48.c8e9eed6.png";